<template>
  <v-layout justify-center align-center fill-height pl-2 pt-4 pr-2 pb-2 row>
    <v-flex xs12 sm10 md9 lg7 pl-2>
      <SimpleCard>
        <v-layout row wrap>
          <v-flex xs12>
            <h2>Create User</h2>
          </v-flex>
          <v-flex xs12 md12>
            <UserForm
              ref="userForm"
              :disabled="false"
              :user="user"
              :errors="errors"
              @validityChange="updateFormValidity($event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 md12 pt-1>
            <v-layout align-center justify-end row>
              <v-btn color="success" @click="submit" class="text-none">Submit</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import UserForm from "@/components/customer/UserForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "create_customer",
  components: {
    SimpleCard,
    UserForm
  },
  data: function() {
    return {
      user: {
        name: "",
        email: "",
        contact_number: "",
        password: "",
        position: "",
        notes: "",
        referral_code: "",
        discount_percentage: "",
        locked_out: false,
        third_party: false,
        accounting_reference_number: ""
      },
      errors: {},
      userFormValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null
    };
  },
  methods: {
    submit: async function() {
      if (this.userFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/customer/create`;
        axios({
          url: url,
          method: "post",
          data: {
            user: this.user
          },
          headers: {
            "Content-Type": "text/plain"
          }
        })
          .then(function(response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error adding customer, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error adding customer: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              const userID = response.data.user.id;
              self.$router.push("../customer/view/" + userID);
            }
          })
          .catch(function(error) {
            console.log(error);
            self.snackbarMessage = "Network error: " + error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.userForm.validateForm();
      }
    },
    updateFormValidity: function(value) {
      this.userFormValid = value;
    }
  }
};
</script>